class LocalizeByIpError extends Error {
  constructor(message = 'Unknown IP localization error') {
    super(message);
    this.name = "LocalizeByIpError";
    this.message = message;
  }
}

export default LocalizeByIpError;